<template lang="pug">
  b-modal(
    v-model="show",
  )
    template(v-slot:modal-header).modal-header
      h5.modal-title {{dialog.title}}
    b-container(fluid, v-html="dialog.context")
    div.w-100(slot="modal-footer", :class="{'remoteClass': dialog.requestType === 'remote'}")
      div
        b-btn(
          v-if='!AppState.isMobile && downloadFlag'
          class="float-right ml-1"
          size="sm"
          variant="secondary"
          @click="onClickDownload"
        ) {{$t('download')}}
      div
        b-btn(
          class="float-right ml-1"
          v-for="(button, index) in dialog.buttons"
          :key="index"
          :size="button.size"
          :variant="button.color"
          @click="button.action(close)"
        ) {{button.text}}
        b-btn(
          class="float-right ml-1"
          size="sm"
          variant="secondary"
          @click="onClickCancel"
        ) {{$t('cancel')}}
</template>

<script>
import _ from 'lodash'
import {user} from '@/api/access'

const defaultValues = {
  size: 'lg',
  title: '',
  context: '',
  buttons: [],
  headerBgVariant: 'light',
  headerTextVariant: 'dark',
  bodyBgVariant: 'light',
  bodyTextVariant: 'dark',
  footerBgVariant: 'light',
  footerTextVariant: 'dark'
}

export default {
  name: 'action-dialog',
  methods: {
    close () {
      this.show = false
    },
    onClickCancel () {
      this.show = false
    },
    onClickDownload() {
      const usr = user()
      let dev = this.dialog.device
      let now = new Date()
      let pivot = new Date('2017-04-01')
      let serverNum = parseInt((now.getTime() - pivot.getTime()) / 1000)
      document.title = [
        'PCCL_CONTROL',
        'RC',
        usr.token,
        dev.dev_os_id + dev.guid,
        usr.company_fk,
        dev.dev_os_id,
        serverNum,
        ''
      ].join('-')
      
      const timestamp = new Date().getTime()
      window.open(`${process.env.VUE_APP_API_ADDRESS}/download/PCCLLauncher.exe?cache=${timestamp}`, '_blank')
      this.$awn.success(this.$t(`remote.remote.download`))
      this.show = false
    },
  },
  created () {
    this.dialog = defaultValues
    this.AppState.$on('show-action-dialog', data => {
      this.dialog = _.assign(this.dialog, data)
      this.show = true
      this.downloadFlag = data.requestType === 'remote'
    })
  },
  data () {
    return {
      show: false,
      dialog: {},
      downloadFlag: false,
    }
  },
}
</script>

<!--<style lang="scss" scoped src="./dialogs.scss"></style>-->
<style lang="scss" scoped>
::v-deep .modal-header {
  background-color: #FAFAFA !important;
  padding: 1rem 1rem 0.75rem 1rem;
  h5 {
    font-size: 1.1rem;
    font-weight: 550;
  }
}

.container-fluid {
  padding-left: 0;
  font-size: 0.9rem;
  color: #545B64;
}

::v-deep .modal-footer {
  border: none;
}

.btn-primary {
  color: white;
  &:hover {
    color: white;
  }
  &:active{
    color: white;
  }
}

.btn-secondary {
  color: #6F6F6F !important;
  background-color: #FFFFFF;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.remoteClass {
  display: flex;
  justify-content: space-between;
}
</style>
